// extracted by mini-css-extract-plugin
export default {"productGallery":"bN-z","inQuickShop":"cN-z"};